var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPvxLogoBlackText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 27,
    viewBox: "0 0 193 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8089 0.988281L8.46227 1.75768V12.9839L12.9109 11.6204C14.0388 11.2747 14.8089 10.2333 14.8089 9.05361V0.988281Z",
    fill: "url(#paint0_linear_199_12350)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21797 2.50556C0.952855 2.65575 0 3.72841 0 5.00241V19.0689L4.63101 17.7069C5.77357 17.3709 6.55818 16.3223 6.55818 15.1313V1.99032L2.21797 2.50556Z",
    fill: "url(#paint1_linear_199_12350)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36597 26.0133L15.7126 25.2439V14.0176L11.2639 15.3811C10.136 15.7268 9.36597 16.7683 9.36597 17.948V26.0133Z",
    fill: "url(#paint2_linear_199_12350)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36597 26.0133L15.7126 25.2439V14.0176L11.2639 15.3811C10.136 15.7268 9.36597 16.7683 9.36597 17.948V26.0133Z",
    fill: "url(#paint3_linear_199_12350)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36597 26.0133L15.7126 25.2439V14.0176L11.2639 15.3811C10.136 15.7268 9.36597 16.7683 9.36597 17.948V26.0133Z",
    fill: "#DDEFEF",
    fillOpacity: 0.53
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9568 24.496C23.2219 24.3458 24.1747 23.2732 24.1747 21.9992V7.93262L19.5437 9.29464C18.4012 9.63068 17.6165 10.6793 17.6165 11.8702V25.0112L21.9568 24.496Z",
    fill: "url(#paint4_linear_199_12350)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9568 24.496C23.2219 24.3458 24.1747 23.2732 24.1747 21.9992V7.93262L19.5437 9.29464C18.4012 9.63068 17.6165 10.6793 17.6165 11.8702V25.0112L21.9568 24.496Z",
    fill: "url(#paint5_linear_199_12350)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9568 24.496C23.2219 24.3458 24.1747 23.2732 24.1747 21.9992V7.93262L19.5437 9.29464C18.4012 9.63068 17.6165 10.6793 17.6165 11.8702V25.0112L21.9568 24.496Z",
    fill: "#DDEFEF",
    fillOpacity: 0.53
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.839 22.6245C184.976 22.6245 183.079 22.0467 181.147 20.8911V17.8124C181.803 18.3643 182.656 18.8731 183.708 19.3388C184.761 19.8045 185.804 20.0373 186.839 20.0373C187.581 20.0373 188.184 19.8994 188.65 19.6234C189.133 19.3474 189.374 18.9766 189.374 18.5109C189.374 18.0625 189.107 17.7003 188.572 17.4243C188.038 17.1311 187.132 16.8465 185.856 16.5705C184.166 16.2083 182.915 15.7254 182.104 15.1217C181.311 14.5008 180.914 13.6556 180.914 12.5863C180.914 11.3099 181.449 10.3096 182.518 9.58514C183.588 8.84348 184.907 8.47266 186.477 8.47266C188.184 8.47266 189.944 8.97284 191.755 9.97322V12.7156C189.857 11.5945 188.098 11.034 186.477 11.034C185.735 11.034 185.123 11.1806 184.64 11.4738C184.157 11.7497 183.915 12.1206 183.915 12.5863C183.915 12.707 183.933 12.8191 183.967 12.9226C184.002 13.0261 184.062 13.121 184.148 13.2072C184.235 13.2762 184.321 13.3452 184.407 13.4142C184.493 13.4832 184.614 13.5521 184.769 13.6211C184.942 13.6729 185.088 13.7246 185.209 13.7764C185.347 13.8281 185.528 13.8799 185.752 13.9316C185.994 13.9833 186.192 14.0351 186.347 14.0868C186.52 14.1213 186.753 14.1731 187.046 14.2421C187.356 14.2938 187.606 14.3455 187.796 14.3973C189.417 14.7767 190.582 15.3114 191.289 16.0013C191.996 16.674 192.35 17.5192 192.35 18.5368C192.35 19.8994 191.815 20.9256 190.746 21.6155C189.676 22.2882 188.374 22.6245 186.839 22.6245Z",
    fill: "#101112"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M171.156 22.4155V8.70349H174.132V11.3371C174.563 10.4747 175.227 9.44515 176.124 9.01396C177.021 8.56551 178.116 8.44478 179.41 8.65175V11.8081C178.013 11.3769 176.779 11.5149 175.71 12.2221C174.658 12.9292 174.132 14.0072 174.132 15.456V22.4155H171.156Z",
    fill: "#101112"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M162.319 22.6245C160.353 22.6245 158.688 21.9346 157.326 20.5548C155.963 19.1577 155.282 17.4847 155.282 15.5357C155.282 13.5694 155.972 11.905 157.352 10.5424C158.732 9.16257 160.387 8.47266 162.319 8.47266C164.027 8.47266 165.527 9.03321 166.821 10.1543C168.132 11.2582 168.934 12.6466 169.227 14.3197C169.399 15.1303 169.408 15.9065 169.253 16.6481H158.231C158.404 17.6658 158.87 18.4764 159.628 19.0801C160.387 19.6665 161.284 19.9597 162.319 19.9597C163.906 19.9597 165.174 19.3992 166.122 18.2781L168.761 18.9766C168.209 20.0805 167.33 20.9687 166.122 21.6414C164.915 22.2968 163.647 22.6245 162.319 22.6245ZM158.231 14.3455H166.329C166.157 13.4314 165.7 12.6639 164.958 12.043C164.234 11.422 163.345 11.1116 162.293 11.1116C161.241 11.1116 160.344 11.4307 159.603 12.0688C158.861 12.6898 158.404 13.4487 158.231 14.3455Z",
    fill: "#101112"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.466 22.4175V8.7055H143.442V10.8993C144.494 9.53671 145.917 8.47266 147.71 8.47266C149.28 8.47266 150.625 8.98147 151.746 9.99909C152.885 10.9995 153.454 12.3362 153.454 14.0092V22.4175H150.479V14.8112C150.479 13.7074 150.151 12.8364 149.496 12.1982C148.857 11.56 148.073 11.2409 147.141 11.2409C146.055 11.2409 145.166 11.6376 144.476 12.431C143.787 13.2072 143.442 14.1817 143.442 15.3546V22.4175H140.466Z",
    fill: "#101112"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.443 22.3122C136.321 22.8986 134.579 22.8124 133.217 22.0535C131.854 21.2946 131.173 19.9406 131.173 17.9916L131.199 11.265H128.611V8.70365H131.199L131.224 5.31445H134.148V8.70365H138.339V11.265H134.148L134.122 17.9658C134.122 18.8109 134.476 19.3801 135.183 19.6733C135.89 19.9665 136.977 19.8889 138.443 19.4404V22.3122Z",
    fill: "#101112"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.105 22.4155V8.70349H122.08V11.3371C122.511 10.4747 123.175 9.44515 124.072 9.01396C124.969 8.56551 126.064 8.44478 127.358 8.65175V11.8081C125.961 11.3769 124.728 11.5149 123.658 12.2221C122.606 12.9292 122.08 14.0072 122.08 15.456V22.4155H119.105Z",
    fill: "#101112"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.046 22.6245C108.443 22.6245 107.856 22.5555 107.287 22.4175C106.735 22.2796 106.201 22.064 105.683 21.7708C105.166 21.4603 104.743 21.0205 104.415 20.4513C104.088 19.8649 103.924 19.1836 103.924 18.4074C103.907 17.0103 104.389 15.9496 105.373 15.2252C106.356 14.4835 107.761 14.1127 109.59 14.1127H113.755V13.2848C113.755 12.5259 113.445 11.9567 112.824 11.5773C112.203 11.1806 111.401 10.9822 110.418 10.9822C108.538 10.9822 107.442 11.6031 107.132 12.845L104.286 12.8967C104.32 11.5341 104.916 10.4562 106.071 9.66276C107.244 8.86936 108.676 8.47266 110.366 8.47266C112.073 8.47266 113.531 8.8866 114.738 9.7145C115.963 10.5424 116.575 11.6118 116.575 12.9226V22.4175H113.755V20.3478C113.358 20.8997 112.755 21.4172 111.944 21.9001C111.151 22.383 110.185 22.6245 109.046 22.6245ZM109.279 20.1667C110.418 20.1667 111.444 19.7786 112.358 19.0025C113.289 18.2263 113.755 17.3122 113.755 16.2601H110.107C108.986 16.2601 108.15 16.4757 107.598 16.9069C107.063 17.3208 106.83 17.8469 106.899 18.485C106.951 19.0715 107.21 19.5027 107.675 19.7786C108.141 20.0373 108.676 20.1667 109.279 20.1667Z",
    fill: "#101112"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7527 22.4159V4.30566H96.8091C98.5511 4.30566 99.9999 4.90072 101.156 6.09082C102.311 7.26367 102.889 8.68662 102.889 10.3597C102.889 12.0499 102.311 13.4729 101.156 14.6285C100.017 15.7669 98.5684 16.3447 96.8091 16.3619L91.8314 16.3878V22.4159H88.7527ZM91.8314 13.6195L96.6021 13.5936C97.6025 13.5936 98.4045 13.2745 99.0082 12.6364C99.6119 11.981 99.9137 11.1876 99.9137 10.2562C99.9137 9.34204 99.6119 8.58313 99.0082 7.97946C98.4218 7.37578 97.6197 7.07394 96.6021 7.07394L91.8314 7.09982V13.6195Z",
    fill: "#101112"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9546 22.4159L69.1121 13.3608L62.9546 4.30566H66.5249L71.337 11.5498L76.1492 4.30566H79.7454L73.5361 13.3608L79.7454 22.4159H76.1492L71.337 15.1718L66.5249 22.4159H62.9546Z",
    fill: "#101112"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9978 22.4142L48.4702 8.70215H51.6524L55.4297 20.898L59.207 8.70215H62.3892L57.8875 22.4142H52.9978Z",
    fill: "#101112"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1748 22.4159V4.30566H40.2312C41.9732 4.30566 43.4221 4.90072 44.5777 6.09082C45.7333 7.26367 46.3111 8.68662 46.3111 10.3597C46.3111 12.0499 45.7333 13.4729 44.5777 14.6285C43.4393 15.7669 41.9905 16.3447 40.2312 16.3619L35.2535 16.3878V22.4159H32.1748ZM35.2535 13.6195L40.0242 13.5936C41.0246 13.5936 41.8266 13.2745 42.4303 12.6364C43.034 11.981 43.3358 11.1876 43.3358 10.2562C43.3358 9.34204 43.034 8.58313 42.4303 7.97946C41.8439 7.37578 41.0419 7.07394 40.0242 7.07394L35.2535 7.09982V13.6195Z",
    fill: "#101112"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_199_12350",
    x1: -3.46268e-7,
    y1: 16.4926,
    x2: 38.2859,
    y2: -5.56764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_199_12350",
    x1: -3.46268e-7,
    y1: 16.4926,
    x2: 38.2859,
    y2: -5.56764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_199_12350",
    x1: 4.5054,
    y1: 26.0048,
    x2: 59.5493,
    y2: 4.28304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_199_12350",
    x1: 24.1748,
    y1: 10.509,
    x2: -14.1109,
    y2: 32.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_199_12350",
    x1: 4.5054,
    y1: 26.0048,
    x2: 59.5493,
    y2: 4.28304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_199_12350",
    x1: 24.1748,
    y1: 10.509,
    x2: -14.1109,
    y2: 32.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvxLogoBlackText);
export default __webpack_public_path__ + "static/media/pvx-logo-black-text.df07f563a0329cd6ad3a04f8d5836440.svg";
export { ForwardRef as ReactComponent };